/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoredFilterCreateRequest } from '../../models/stored-filter-create-request';
import { StoredFilterCreateResponse } from '../../models/stored-filter-create-response';

export interface CreateStoredFilter$Params {
      body: StoredFilterCreateRequest
}

export function createStoredFilter(http: HttpClient, rootUrl: string, params: CreateStoredFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<StoredFilterCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, createStoredFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoredFilterCreateResponse>;
    })
  );
}

createStoredFilter.PATH = '/filters';
